import React from "react";
//#region types
import { TodoDocumentTypeSelectionStepProps } from "models/propTypes/missingDocumentPropTypes";
import { ChoiceProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { SelectionItem } from "models/utilTypes/selectionTypes";
//#endregion
//#region components
import { useReceiptPermissions } from "components/receipt";
import { Choice, VerticalFormField } from "components/common/wintForms";
import { useIncomingInvoicePermissions } from "components/incomingInvoice";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const TodoDocumentTypeSelectionStep: React.FC<TodoDocumentTypeSelectionStepProps> = ({
  hasMatchedDocument,
  amount,
  date,
  values,
  connect,
}) => {
  const { canCreateIncomingInvoices, canViewIncomingInvoices } = useIncomingInvoicePermissions();
  const { receiptCreator } = useReceiptPermissions();

  const availableDocumentTypes: SelectionItem[] = React.useMemo(() => {
    if (hasMatchedDocument) return [];

    const documentTypes: WintSuperkollAPIModel.MissingDocumentPutType[] = [];

    if (receiptCreator && DateHelper.isBefore(new Date(date), DateHelper.tomorrow())) {
      documentTypes.push(WintSuperkollAPIModel.MissingDocumentPutType.Receipt);
    }

    if (canCreateIncomingInvoices && canViewIncomingInvoices) {
      documentTypes.push(WintSuperkollAPIModel.MissingDocumentPutType.IncomingInvoice);
    }

    documentTypes.push(WintSuperkollAPIModel.MissingDocumentPutType.Other);

    return documentTypes.map((type) => ({
      id: type,
      value: LocalizationHelperInstance.getTranslatedEnumValue("MissingDocument.Types", type),
    }));
  }, [hasMatchedDocument, canCreateIncomingInvoices, canViewIncomingInvoices]);

  return (
    <>
      {hasMatchedDocument || amount > 0 || (!values.filesToUpload?.length) ? (
        <></>
      ) : (
        <VerticalFormField<ChoiceProps>
          Component={Choice}
          {...connect("type")}
          label={TranslationKeys.MissingDocument.DocumentType}
          items={availableDocumentTypes ?? []}
          showMainLabel
        />
      )}
    </>
  );
};

export default TodoDocumentTypeSelectionStep;
